import { Component, OnInit } from '@angular/core';
import { ResultsService } from '../../../services/results.service';

@Component({
  selector: 'app-terms-of-use',
  templateUrl: './terms-of-use.component.html',
  styleUrls: ['./terms-of-use.component.css']
})
export class TermsOfUseComponent implements OnInit {
  termsContent:string="Your Terms of Use Content Here";
  fileName: string = "TermsOfUse";
  interval:any;
  constructor(private resultservice: ResultsService) { }

  ngOnInit() {
    this.GetDefaultPrefernces();
    this.interval = setInterval(() => { 
      this.GetDefaultPrefernces(); 
  }, 10000);
  }


  GetDefaultPrefernces() {
    this.resultservice.getAllPreferences(this.fileName).then((result: any) => {
      if (result != null && result != '' && result != undefined) {
        this.termsContent = result.content;
      }
    });
  }
}
